import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createOrganizationsActions } from './organizations.actions'
import { organizationsInitialState } from './organizations.slice'
import type { OrganizationsStore } from './organizations.type'

export const useOrganizationsStore = create<OrganizationsStore>()(
  devtools(
    subscribeWithSelector(
      immer((set) => ({
        ...organizationsInitialState,
        ...createOrganizationsActions(set),
      }))
    ),
    {
      name: StoreDevtoolsName.OrganizationsSettings,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
